module.exports = __webpack_public_path__ + "media/images/favicons/og-image-8b554664e04f0bdc9c47a17d9f499d4c.jpg";